module.exports = __webpack_public_path__ + "img/payments.581c2211.svg";